(function(){
  function setTrustCard(card,title,text){
    if(!card)return;
    var h=card.querySelector('h3');
    var p=card.querySelector('p');
    if(h)h.textContent=title;
    if(p)p.textContent=text;
  }

  function run(){
    var en=(document.documentElement.lang||'').toLowerCase().indexOf('en')===0;
    var path=window.location.pathname||'';
    var trust=document.querySelectorAll('.sorivo-trust__item');

    if(path.indexOf('/products/sorivo-flexstand-flexibler-smartphone-tablet-stander')!==-1 || path.indexOf('/products/sorivo-flexstand-flexible-smartphone-tablet-stand')!==-1){
      if(trust.length>=4){
        setTrustCard(trust[2],en?'Shapeable & non-slip':'Flexibel & rutschfest',en?'The silicone surface helps keep devices secure while the flexible aluminum inner layer holds the angle you set.':'Die Silikonoberfläche sorgt für sicheren Halt, während die flexible Aluminium-Innenschicht den gewünschten Winkel beibehält.');
        setTrustCard(trust[3],en?'For smartphone & tablet':'Für Smartphone & Tablet',en?'FlexStand does not charge. It positions a smartphone or tablet at the angle you want at your desk, while streaming or on the go.':'FlexStand lädt nicht: Er positioniert Smartphone oder Tablet flexibel am Schreibtisch, beim Streaming oder unterwegs.');
      }
    }

    if(path.indexOf('/products/sorivo-snapfold-3-in-1')!==-1){
      if(trust.length>=4){
        setTrustCard(trust[2],en?'Magnetic & foldable':'Magnetisch & faltbar',en?'Compact 3-in-1 design with magnetic smartphone alignment and a foldable form for desk, bedside table and travel.':'Kompaktes 3-in-1 Design mit magnetischer Smartphone-Ausrichtung und faltbarer Form für Schreibtisch, Nachttisch und Reise.');
        setTrustCard(trust[3],en?'3 devices, 1 charging place':'3 Geräte, 1 Ladeplatz',en?'For a compatible smartphone, smartwatch and wirelessly chargeable earbuds. Smartphone output is up to 15 W depending on device and power source.':'Für kompatibles Smartphone, Smartwatch und kabellos ladbare Earbuds. Die Smartphone-Ladeleistung beträgt je nach Gerät und Stromversorgung bis zu 15 W.');
      }
    }

    var flex=document.querySelector('#sorivo-flexstand [data-sorivo-carousel]');
    if(flex && flex.dataset.sorivoV11Orange!=='1'){
      flex.dataset.sorivoV11Orange='1';
      window.setTimeout(function(){
        var dots=flex.querySelectorAll('[data-dot]');
        if(dots.length>1){dots[1].click();}
        var swatches=flex.querySelectorAll('.sorivo-v6-swatch');
        if(swatches.length>1){
          swatches[0].classList.remove('is-selected');
          swatches[1].classList.add('is-selected');
        }
        var cta=flex.querySelector('.sorivo-v6-cta');
        if(cta){
          cta.href='/products/sorivo-flexstand-flexibler-smartphone-tablet-stander?variant=54014204379483';
          cta.innerHTML=(en?'Discover in Orange':'Produkt in Orange entdecken')+'<span>→</span>';
        }
      },120);
    }
  }

  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded',function(){window.setTimeout(run,160);},{once:true});
  }else{
    window.setTimeout(run,160);
  }
})();